module.exports = __webpack_public_path__ + "static/media/g1.fcd9490c.png";